<div  *ngIf="!kycRequested else kycVerification">
  <div class="profile-wrapper mobile" fxLayout="column" fxLayoutAlign="start">
    <div fxFlex="none" class="top-container" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
      <!-- <ng-container *ngIf="avatar"> -->
        <div class="vip-avatar" *ngIf="userRole else regularAvatar">
          <div class="vip-img-content">
            <img class="vip-player-img" src="{{avatar}}" />
            <div class="role" i18n>vip</div>
          </div>
          <img class="vip-leef" src="{{licenceService.getKey('icon-vip-leef')}}">
        </div>
        <ng-template #regularAvatar>
          <img class="regular-player-img" src="{{avatar}}" />
        </ng-template>
      <!-- </ng-container> -->
      <div *ngIf="!kyc_status" fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="8px" style="overflow: hidden;">
        <div *ngIf="verified" class="verified" i18n class="max-width-inherit">Verified</div>
        <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;width: 100%;" [title]="email" i18n>{{email}}</div>
      </div>
      <div [ngSwitch]="kyc_status" [style.width]="'100%'">
        <div *ngSwitchCase="'account unverified'">
          <div class="upload_doc-status unverified-status max-width-content"><img src="{{licenceService.getKey('icon-unverified-badge')}}" alt="icon-unverified-badge"><span i18n class="max-width-inherit">ACCOUNT UNVERIFIED</span></div>
        </div>
        <div *ngSwitchCase="'upload documents'">
          <div class="upload_doc-status-container">
            <div class="upload_doc-status max-width-content"><img src="{{licenceService.getKey('icon-upload-doc-badge')}}" alt="icon-upload-doc-badge"><span i18n class="max-width-inherit">UPLOAD DOCUMENTS</span></div>
            <button round-button color="primary" filled="filled" size="small" (click)="completeKyc()"><span i18n>Upload</span> <img src="{{licenceService.getKey('upload-icon')}}" alt="upload-icon"></button>
          </div>
        </div>
        <div *ngSwitchCase="'verification in progress'">
          <div class="verification-status-container">
            <div class="upload_doc-status verification-status max-width-content"><img src="{{licenceService.getKey('icon-verification-badge')}}" alt="icon-verification-badge"><span i18n class="max-width-inherit">VERIFICATION IN PROGRESS</span></div>
            <div *ngIf="userInfo?.kyc_requested" class="verification-info" [routerLink]="uploadDocumentsTrx"><img src="{{licenceService.getKey('icon-info')}}" alt="icon-info"></div>
          </div>
        </div>
        <div *ngSwitchCase="'account verified'">
          <div class="upload_doc-status verified-status max-width-content"><img src="{{licenceService.getKey('icon-verified-badge')}}" alt="icon-verified-badge"><span i18n class="max-width-inherit">ACCOUNT VERIFIED</span></div>
        </div>
      </div>
    </div>
    <!-- <div fxFlex="none" class="level-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
      <div class="level-container-img-box">
        <div class="image" [ngStyle]="{'background': userRole ? 'var(--image-border-gradient)' : 'var(--image-border)'}">
          <div class="icon-player-level">
          <img *ngIf="lemonIconNameIndex" src="assets/luckera/icons/level-icon/icon-level-{{lemonIconNameIndex}}.svg" alt="icon-gamification" />
          </div>
          <div *ngIf="playerLoyalityName" class="label" [ngClass]="{'vip-label':userRole}">{{playerLoyalityName}}</div>
        </div>
        <div class="label-level" i18n>{{playerLevelPosition}}</div>
      </div>
      <div class="level-progress-container" fxLayout="column" fxLayoutGap="8px">
        <div class="level-progress-number" fxLayout="row" fxLayoutAlign="space-around center">
          <div *ngFor="let levelValue of playerCurrentLevelList" class="number" [ngClass]="{ 'completed': gamificationLevel > levelValue, 'current': levelValue == gamificationLevel }">{{levelValue}}</div>
        </div>
        <div class="profile-level-progress">
          <mat-progress-bar color="accent" mode="determinate" [value]="gamificationTotalLevelPercent" [ngClass]="gamificationTotalLevelPercent===100 ? 'value-comleted' : 'value-not-comleted'">
          </mat-progress-bar>
          <div class="level-divider-container" fxLayout="row" fxLayoutAlign="space-evenly center">
            <div class="level-divider"></div>
            <div class="level-divider"></div>
            <div class="level-divider"></div>
            <div class="level-divider"></div>
          </div>
          <div class="current-number-percent" [ngStyle]="{'left.%':gamificationTotalLevelPercent}">
            <div class="percent-up-arrow"></div>
            <div class="percent-number" *ngIf="gamificationPercentFill < 100 else PercentFill">{{gamificationPercentFill.toFixed(2)}}%</div>
            <ng-template #PercentFill>
              <div class="percent-number">{{gamificationPercentFill.toFixed(0)}}%</div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="level-container-img-box">
        <div class="image"> 
          <div class="icon-player-level">
          <img *ngIf="lemonNextLevelIconNameIndex" src="assets/luckera/icons/level-icon/icon-level-{{lemonNextLevelIconNameIndex}}.svg" alt="icon-gamification" />
          </div>
          <div *ngIf="playerLoyalityName" class="label" [ngClass]="{'vip-label':userRole}">{{playerNextLoyalityName}}</div>
        </div>
        <div class="label-level" i18n>{{playerNextLevelPosition}}</div>
      </div>
    </div> -->
  </div>
  <div class="items">
    <div class="item-wrapper light" [ngClass]="{'active-Lottery': bonusQueue?.length > 0}">
      <div class="item">
        <div class="spinner-container">
          <div class="spinner-background">
            <!-- <img *ngIf="isPrizeBoxActive && showGamification" src="{{licenceService.getKey('level-1-icon')}}" alt="icon-gamification" />
            <img *ngIf="!isPrizeBoxActive && showGamification" src="{{licenceService.getKey('level-1-icon')}}" alt="icon-gamification" /> -->
            <img *ngIf="isPrizeBoxActive || !lemonIconNameIndex"  src="{{licenceService.getKey('icon-mybonus-icon-mobile')}}" width="20px" height="20px" />
            <span *ngIf="!isPrizeBoxActive && lemonIconNameIndex" style="margin-top: -4px;">{{lemonIconNameIndex}}</span>
          </div>
          <mat-progress-spinner #spinnerlevel color="accent" mode="determinate" [value]="gamificationPercentFill" [diameter]="56" style="stroke-linecap: round;">
          </mat-progress-spinner>
        </div>
        <div class="text-container">
          <div class="title" i18n>My Bonuses</div>
          <div i18n>Collect your prize!</div>
          <!-- <div *ngIf="isPrizeBoxActive" i18n>Collect your prize!</div> -->
          <!-- <div *ngIf="!isPrizeBoxActive" style="color: #DADADA;"><span i18n>Level</span> {{gamificationLevel}} <span i18n>completed in</span> {{gamificationPercentFill.toFixed(2)}}%</div> -->
        </div>
  
        <div class="info">
          <a [routerLink]="bonusesUrl" rel="noreferrer" routerLinkActive="active">
            <img src="{{licenceService.getKey('icon-info')}}" />
          </a>
        </div>
      </div>
      <button round-button filled="filled" color="warn" [routerLink]="bonusesUrl"  [disabled]="bonusQueue?.length == 0|| !bonusQueue" i18n>Action</button>
    </div>
  
    <div class="item-wrapper light" [ngClass]="{'active-Lottery': userBonusLotteryResponse}">
      <div class="item">
        <div class="icon-container">
          <img *ngIf="userBonusLotteryResponse" src="{{licenceService.getKey('icon-bonus-wheel')}}" />
          <img *ngIf="!userBonusLotteryResponse" src="{{licenceService.getKey('icon-bonus-wheel')}}" />
        </div>
        <div class="text-container">
          <div class="title" i18n>Luckera Wheel</div>
          <div *ngIf="userBonusLotteryResponse" i18n>Claim your free ticket!</div>
          <div *ngIf="!userBonusLotteryResponse" style="color: #DADADA;" i18n>No active spin</div>
        </div>
        <div class="info">
          <a routerLink="/info/luckera-wheel" rel="noreferrer" routerLinkActive="active">
            <img src="{{licenceService.getKey('icon-info')}}">
          </a>
        </div>
      </div>
      <button round-button filled="filled" color="warn" (click)="openLotteryWheel()" [disabled]="!userBonusLotteryResponse" i18n>Spin!</button>
    </div>
  
    <div *ngIf="!cashBackTwoActive" class="item-wrapper light" [ngClass]="{'active-Lottery': userChargebackToClaim}">
      <div class="item">
        <div class="spinner-container">
          <div class="spinner-background" [ngClass]="{'spinner-background-active':!!userChargebackToClaim && showGamification}">
            <img src="{{licenceService.getKey('icon-daily-cashback')}}" alt="icon-gamification" />
            <!-- <img *ngIf="!!userChargebackToClaim && showGamification" src="{{licenceService.getKey('icon-daily-cashback')}}" alt="icon-gamification" /> -->
          </div>
          <mat-progress-spinner *ngIf="!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="chargebackPercentFill" [diameter]="56" style="stroke-linecap: round;">
          </mat-progress-spinner>
          <mat-progress-spinner *ngIf="!!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="100" [diameter]="56" style="stroke-linecap: round;">
          </mat-progress-spinner>
        </div>
        <div class="text-container">
          <div i18n class="title">Cashback</div>
          <div class="cash">{{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.value?.toFixed(2)}} {{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.currency}}</div>
          <div *ngIf="!userChargebackToClaim && dailyChargebackFormatted" style="color: #DADADA;"><span i18n>Next payout in:</span>&nbsp;{{dailyChargebackFormatted}}</div>
        </div>
        <div class="info">
          <a [routerLink]="cashbackInfoUrl" rel="noreferrer" routerLinkActive="active">
            <img src="{{licenceService.getKey('icon-info')}}">
          </a>
        </div>
      </div>
      <button round-button filled="filled" color="warn" (click)="claimCashback()" [disabled]="!userChargebackToClaim" i18n>Claim!</button>
    </div>
  
    <div *ngIf="cashBackTwoActive" class="profile-cashback-container" [ngClass]="{'active-slider-lottery': userChargebackToClaim || userChargebackToClaim} ">
      <swiper fxFlex="auto" class="profile-cashback-swiper" [config]="config">
        <ng-template swiperSlide>
          <div class="item-wrapper light" [ngClass]="{'active-cashback': userChargebackToClaim}">
            <div class="item">
              <div class="spinner-container">
                <div class="spinner-background" [ngClass]="{'spinner-background-active':!!userChargebackToClaim && showGamification}">
                  <img *ngIf="!userChargebackToClaim && showGamification" src="{{licenceService.getKey('icon-cashback')}}" alt="icon-gamification" />
                  <img *ngIf="!!userChargebackToClaim && showGamification" src="{{licenceService.getKey('icon-cashback')}}" alt="icon-gamification" />
                </div>
                <mat-progress-spinner *ngIf="!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="chargebackPercentFill" [diameter]="56" style="stroke-linecap: round;">
                </mat-progress-spinner>
                <mat-progress-spinner *ngIf="!!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="100" [diameter]="56" style="stroke-linecap: round;">
                </mat-progress-spinner>
              </div>
              <div class="text-container">
                <div i18n>Cashback 1 earned:</div>
                <div class="title" i18n>{{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.value?.toFixed(2)}} {{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.currency}}</div>
                <div *ngIf="!userChargebackToClaim && chargebackFormatted" style="color: #DADADA;"><span i18n>Next payout in:</span>&nbsp;{{chargebackFormatted}}</div>
              </div>
              <div class="info">
                <a [routerLink]="cashbackInfoUrl" rel="noreferrer" routerLinkActive="active">
                  <img src="{{licenceService.getKey('icon-info')}}">
                </a>
              </div>
            </div>
            <button round-button filled="filled" color="warn" (click)="claimCashback()" [disabled]="!userChargebackToClaim" i18n>Claim!</button>
          </div>
        </ng-template>
        <ng-template swiperSlide>
          <div class="item-wrapper light" [ngClass]="{'active-cashback': userChargebackToClaim}">
            <div class="item">
              <div class="spinner-container">
                <div class="spinner-background" [ngClass]="{'spinner-background-active':!!userChargebackToClaim && showGamification}">
                  <img *ngIf="!userChargebackToClaim && showGamification" src="assets/client-area/icon-cashback-2-off.png" alt="icon-gamification" />
                  <img *ngIf="!!userChargebackToClaim && showGamification" src="assets/client-area/icon-cashback-2-on.png" alt="icon-gamification" />
                </div>
                <mat-progress-spinner *ngIf="!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="chargebackPercentFill" [diameter]="56" style="stroke-linecap: round;">
                </mat-progress-spinner>
                <mat-progress-spinner *ngIf="!!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="100" [diameter]="56" style="stroke-linecap: round;">
                </mat-progress-spinner>
              </div>
              <div class="text-container">
                <div i18n>Cashback 2 earned:</div>
                <div class="title" i18n>{{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.value?.toFixed(2)}} {{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.currency}}</div>
                <div *ngIf="!userChargebackToClaim && chargebackFormatted" style="color: #DADADA;"><span i18n>Next payout in:</span>&nbsp;{{chargebackFormatted}}</div>
              </div>
              <div class="info">
                <a [routerLink]="cashbackInfoUrl" rel="noreferrer" routerLinkActive="active">
                  <img src="{{licenceService.getKey('icon-info')}}">
                </a>
              </div>
            </div>
            <button round-button filled="filled" color="warn" (click)="claimCashback()" [disabled]="!userChargebackToClaim" i18n>Claim!</button>
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
  <div class="items-dark">
    <div class="item-wrapper-dark">
      <div class="item">
        <div class="icon-container-dark">
          <img src="{{licenceService.getKey('profile-my-bonus')}}" />
        </div>
        <div class="text-container">
          <div class="title" i18n>Promo Code</div>
          <div i18n>Manage your bonuses</div>
        </div>
      </div>
      <button round-button filled="empty" color="white" i18n [routerLink]="promoCodeUrl" routerLinkActive="active">Proceed</button>
    </div>
  
    <div class="item-wrapper-dark dark">
      <div class="item">
        <div class="icon-container-dark">
          <img src="{{licenceService.getKey('profile-my-games')}}" />
        </div>
        <div class="text-container">
          <div class="title" i18n>My games</div>
          <div i18n>Manage your collection</div>
        </div>
      </div>
      <button round-button filled="empty" color="white" i18n [routerLink]="myGamesUrl" routerLinkActive="active">Play</button>
    </div>
  </div>
  <!-- <div class="divider-line">
    <mat-divider></mat-divider>
  </div> -->
  <div class="main-wrap">
    <div class="lighter-bg" fxLayout="column" fxLayoutAlign="start center" [routerLink]="editProfileUrl" routerLinkActive="active">
      <img src="{{licenceService.getKey('edit-profile-icon')}}">
      <div class="label mobile">
        <div class="profile-title" i18n >Edit Profile</div>
      </div>
      <button round-button size="small" filled="empty" color="white" i18n [routerLink]="editProfileUrl" routerLinkActive="active">Proceed</button>
    </div>
  
    <div class="lighter-bg" fxLayout="column" fxLayoutAlign="start center" [routerLink]="changePasswordUrl" routerLinkActive="active">
      <img src="{{licenceService.getKey('change-password-icon')}}">
      <div class="label mobile">
        <div class="profile-title" i18n >Change Password</div>
      </div>
      <button round-button size="small" filled="empty" color="white" i18n [routerLink]="changePasswordUrl" routerLinkActive="active">Proceed</button>
    </div>
  </div>
</div>
<ng-template #kycVerification>
  <div class="kyc-container" [ngClass]="isDesktop ? 'desktop': 'mobile'">
      <app-kyc-verification (KycStatus)="getKycStatus($event)"></app-kyc-verification>
  </div>
</ng-template>